'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { useRef, useReducer, useCallback, useEffect } from 'react';

var useFetch = function (url, options, callback) {
    var cache = useRef({});
    var isEnable = options === null || options === void 0 ? void 0 : options.enable;
    var cancelRequest = useRef(false);
    var initialState = {
        data: undefined,
        error: undefined,
        loading: true
    };
    var fetchReducer = function (state, action) {
        switch (action.type) {
            case 'loading':
                return __assign(__assign({}, state), { loading: action.payload });
            case 'fetched':
                callback && callback(action.payload);
                return __assign(__assign({}, state), { data: action.payload });
            case 'error':
                return __assign(__assign({}, state), { error: action.payload });
            default:
                return state;
        }
    };
    var _a = useReducer(fetchReducer, initialState), state = _a[0], dispatch = _a[1];
    var fetchData = useCallback(function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // do nothing if the url not given
                    if (!url)
                        return [2 /*return*/];
                    cancelRequest.current = false;
                    // if has a cache for this url, return it
                    if (cache.current[url]) {
                        dispatch({ type: 'fetched', payload: cache.current[url] });
                        dispatch({ type: 'loading', payload: false });
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, options)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = (_a.sent());
                    cache.current[url] = data;
                    if (cancelRequest.current)
                        return [2 /*return*/];
                    dispatch({ type: 'fetched', payload: data });
                    dispatch({ type: 'loading', payload: false });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (cancelRequest.current)
                        return [2 /*return*/];
                    dispatch({ type: 'loading', payload: false });
                    dispatch({ type: 'error', payload: error_1 });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [url]);
    var additionalDispatch = function (reqOptions) {
        var additionalOptions = __assign(__assign({}, options), reqOptions);
        fetchData(additionalOptions);
    };
    useEffect(function () {
        if (typeof isEnable !== 'undefined' && isEnable === false)
            return;
        fetchData(options);
        // Use the cleanup function for avoiding a possibly...
        // ...state update after the component was unmounted
        return function () {
            cancelRequest.current = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, isEnable]);
    return __assign(__assign({}, state), { dispatch: additionalDispatch });
};

export { useFetch as default };
//# sourceMappingURL=useFetch.js.map
